import { useContext } from "react";
import { AuthContext } from "../context/AuthContext";
/**
 * Custom Hook to access the authentication context
 * Provides a clean way to consume AuthContext values
 */

export const useAuth = () => {
  const context = useContext(AuthContext);

  if (context === undefined) {
    throw new Error("useAuth debe ser usado dentro de un AuthProvider");
  }

  return context;
};
